var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.7231 13L16.1675 10.1044H13.3891V8.22531C13.3891 7.43313 13.7772 6.66094 15.0216 6.66094H16.2847V4.19563C16.2847 4.19563 15.1384 4 14.0425 4C11.7544 4 10.2587 5.38688 10.2587 7.8975V10.1044H7.7153V13H10.2587V20H13.3891V13H15.7231Z",
    fill: "#1877F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.419857d2db6815e54ddeaadbc1dc2b8d.svg";
export { ForwardRef as ReactComponent };